import React, { useState, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";
import { init } from "../../../components/EventLabel2/EventLabel2";
import { arrayHelper } from "../../../helpers/arrayHelper";
import { combineProps } from "../../../helpers/objectHelper";
import { eventLabelGroupsConstants } from "../../constants/eventLabelGroups.contansts";
import { ChatContainer } from "./components/ChatContainer";
import { backstageChatStyle, chatStyle } from "./helpers/chat.helper";
import ChatBubbleRoundedIcon from "@material-ui/icons/ChatBubbleRounded";
import { Badge, Fab, Tooltip } from "@material-ui/core";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import { withStyles } from "@material-ui/styles";
import CloseIcon from "@material-ui/icons/Close";
import { UndreadMessageSnackbar } from "./components/UnreadMessageSnackbar";
import "./chatModuleStyle.css";
const mockChat = [{}];

function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

function ChatModule(props) {
  const {
    eventId,
    lang,
    allowModeratorChat,
    disableGroupChat,
    elevateParentContainer = () => null,
    hubConnection,
    clientKey,
    clientName,
    settings,
    channel,
    template,
    companyName,
    backstage = false,
    connected,
    preview = false,
  } = props;
  const [chats, setChats] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [currentChat, setCurrentChat] = useState(backstage ? "BACKSTAGE" : disableGroupChat ? "NONE" : "ALL");
  const [autoScrollLocked, setAutoScrollLocked] = useState(false);
  const [chatConnections, setChatConnections] = useState([]);
  const [hiddenMessages, setHiddenMessages] = useState(0);
  const [initalScrollPos, setInitalScrollPos] = useState(null);
  const [missedGroupMessages, setMissedGroupMessages] = useState(0);
  const [messagesToShow, setMessagesToShow] = useState(30);
  const [chatBlock, setChatBlock] = useState(false);
  const [collapsed, setCollapsed] = useState(settings.collapsible);

  const scrollRef = useRef();
  const chatMessageRef = useRef([]);
  const lastMessageRef = useRef();
  const mountedRef = useRef(true);
  const connectionTimer = useRef();

  const prevCurrenChat = usePrevious(currentChat);

  useEffect(() => {
    if (preview) return;
    init(eventId, eventLabelGroupsConstants.CHAT_LABEL_GROUP, lang);
    configureHubEvents();
    return () => {
      mountedRef.current = false;
      lastMessageRef.current = null;
      if (connectionTimer.current) {
        clearInterval(connectionTimer.current);
        connectionTimer.current = null;
      }
    };
  }, []);

  //Initial scroll when chat loaded
  useEffect(() => {
    if (!autoScrollLocked && chats.length != 0 && lastMessageRef.current && !loaded) {
      setLoaded(true);
      setTimeout(() => handleScroll(), 500);
    }
    if (!autoScrollLocked && chats.length != 0 && lastMessageRef.current && currentChat != prevCurrenChat) {
      setTimeout(() => handleScroll(), 500);
    }
  }, [chats, lastMessageRef.current]);

  //Re-assing hubevents when chats has changed
  useEffect(() => {
    if (hubConnection && mountedRef.current == true) {
      hubConnection.on("onSendChatMessage", onSendChatMessage);
      hubConnection.on("onChatMessageReceived", onReceiveMessage);
      hubConnection.on("onLikeMessage", onLikeMessage);
      hubConnection.on("onGetChatMessage", onGetChatMessages);
      hubConnection.on("onMessageRemoved", onMessageRemoved);
      hubConnection.on("onMessageEdit", onMessageEdit);
      hubConnection.on("onClearSharedChat", onClearChatMessages);
      hubConnection.on("onGetActiveChatConnections", onGetActiveChatConnections);
      hubConnection.on("onInteractionExtraSet", onInteractionExtraSet);
      hubConnection.on("onExposeHiddenMessages", onExposeHiddenMessages);
    }
    return () => {
      if (hubConnection) {
        hubConnection.off("onSendChatMessage", onSendChatMessage);
        hubConnection.off("onChatMessageReceived", onReceiveMessage);
        hubConnection.off("onLikeMessage", onLikeMessage);
        hubConnection.off("onGetChatMessage", onGetChatMessages);
        hubConnection.off("onMessageRemoved", onMessageRemoved);
        hubConnection.off("onMessageEdit", onMessageEdit);
        hubConnection.off("onClearSharedChat", onClearChatMessages);
        hubConnection.off("onGetActiveChatConnections", onGetActiveChatConnections);
        hubConnection.off("onInteractionExtraSet", onInteractionExtraSet);
        hubConnection.off("onExposeHiddenMessages", onExposeHiddenMessages);
      }
    };
  });

  const onGetActiveChatConnections = (newChatConnections) => {
    if (arrayHelper.compareChanges(chatConnections, newChatConnections, "clientKey")) {
      setChatConnections(newChatConnections);
    }
  };

  const onInteractionExtraSet = (extra) => {
    if (extra && extra.name == "ChatBlock") {
      setChatBlock(extra.value == "True" ? true : false);
    }
  };

  const configureHubEvents = () => {
    if (hubConnection && mountedRef.current == true) {
      hubConnection.invoke("getChatMessages", settings?.requestedEventId ?? eventId, clientKey, channel, backstage);
      if (settings?.requestedEventId) {
        hubConnection.invoke("joinChatGroup", settings.requestedEventId);
      }
      updateChatConnections();

      if (!connectionTimer.current) {
        connectionTimer.current = setInterval(() => updateChatConnections(), 10000);
      }
    }
  };

  const updateChatConnections = () => {
    if (hubConnection && hubConnection.state == 1) {
      hubConnection.invoke("getActiveChatConnections", settings?.requestedEventId ?? eventId).catch((err) => {});
    }
  };

  const onMessageEdit = (response) => {
    const c = Array.from(chats);
    const targetChat = c.find((c) => c.target == "ALL");
    if (!targetChat) return;
    let chatIndex = c.indexOf(targetChat);
    let messageIndex = targetChat.messages.indexOf(targetChat.messages.find((r) => r.interactionChatId == response.id));
    if (chatIndex > -1 && messageIndex > -1) {
      c[chatIndex].messages[messageIndex].message = response.message;
      setChats(c);
    }
  };

  const onMessageRemoved = (response) => {
    const c = Array.from(chats);
    const targetChat = c.find((c) => c.target == "ALL");
    if (!targetChat) return;
    let chatIndex = c.indexOf(targetChat);
    let messageIndex = targetChat.messages.indexOf(targetChat.messages.find((r) => r.interactionChatId == response.id));
    if (chatIndex > -1 && messageIndex > -1) {
      c[chatIndex].messages[messageIndex].message = response.message;
      setChats(c);
    }
  };

  const onClearChatMessages = () => {
    const c = Array.from(chats);
    chatConnections.map((c) => {
      c.messages = [];
    });
    setChats(c);
  };

  const onGetChatMessages = (c) => {
    setChats(c);
    if (settings?.requestedEventId) handleScroll(true);
  };

  const onExposeHiddenMessages = () => {
    const c = Array.from(chats);
    c.map((c) => {
      if (c.target == "ALL") {
        debugger;
        c.messages.map((m) => {
          m.hidden = false;
        });
      }
    });
    setChats(c);
    setTimeout(() => {
      scrollToBottom();
    }, 500);
  };

  const onReceiveMessage = (message) => {
    const c = Array.from(chats);
    const targetChat = c.find((c) => c.target == message.sender);
    const { senderFirstName, senderLastName } = message;
    let hm = hiddenMessages;

    if (targetChat) {
      let chatIndex = c.indexOf(targetChat);
      if (chatIndex > -1) {
        c[chatIndex].messages.push(message);
        c[chatIndex].previewText = message.message;
        c[chatIndex].previewPrefix = `${senderFirstName} ${senderLastName}`;
        c[chatIndex].lastChange = message.inserted;

        if (currentChat && currentChat != c[chatIndex].target) {
          c[chatIndex].seen = false;
        }
        if (currentChat && currentChat == c[chatIndex].target) {
          setMessageSeen(currentChat);
        }
      }
    } else {
      c.push({
        lastChange: message.inserted,
        messages: [message],
        previewText: message.message,
        previewPreFix: `${senderFirstName} ${senderLastName}`,
        target: message.sender,
        seen: false,
        hidden: message.hidden,
      });
    }
    if ((autoScrollLocked && currentChat && message.sender == currentChat) || collapsed) {
      hm += 1;
    }
    setChats(c);
    setHiddenMessages(hm);
    if (!autoScrollLocked) handleScroll(true);
  };

  const onLikeMessage = (messageId) => {
    const c = Array.from(chats);
    c.map((ci) => {
      ci.messages.map((m) => {
        if (m.interactionChatId == messageId) {
          if (m.likes == null) m.likes = 0;
          m.likes += 1;
        }
      });
    });
    setChats(c);
  };

  const onSendChatMessage = (sentMessage) => {
    if (sentMessage.receiver == "ALL" && sentMessage.room != props.channel) return;
    const { target, receiver, sender, senderFirstName, senderLastName, message, inserted } = sentMessage;
    const c = Array.from(chats);
    const targetChat = c.find((c) => c.target == receiver);

    let mgm = missedGroupMessages;
    let hm = hiddenMessages;

    let chatIndex = c.indexOf(targetChat);
    if (targetChat) {
      c.map((c) => {
        if (c.target == target) {
          c.seen = false;
        }
      });
      if (chatIndex > -1) {
        c[chatIndex].previewText = message;
        c[chatIndex].previewPrefix = senderFirstName + " " + senderLastName;
        c[chatIndex].lastChange = inserted;
        c[chatIndex].messages.push(sentMessage);
        c[chatIndex].messages.map((m) => {
          if (m.sender == clientKey) {
            m.seen = true;
          }
        });
        c[chatIndex].seen = !c[chatIndex].messages.some((m) => m.seen == false);
      }
      mgm += 1;
    } else {
      c.push({
        lastChange: inserted,
        messages: [sentMessage],
        previewText: message,
        previewPreFix: sender == clientKey ? "You" : `${senderFirstName} ${senderLastName}`,
        target: receiver,
        seen: sender == clientKey ? true : false,
        hidden: sentMessage.hidden,
      });
    }

    //If the autoscroll is locked (you been manually scrolling up) and the sender of the message is the same conversation as the one you have selected
    //Or the autoscroll is locked and the receiver is the same conversation and the selected conversation is the group chat
    if ((autoScrollLocked && sender == currentChat) || (autoScrollLocked && receiver == currentChat && currentChat == "ALL") || collapsed) {
      hm += 1;
    }

    setChats(c);
    setHiddenMessages(hiddenMessages);
    setMissedGroupMessages(mgm);

    if (!autoScrollLocked) handleScroll(true);
  };

  const setMessageSeen = (target) => {
    const c = Array.from(chats);
    c.map((c) => {
      if (c.target == target) {
        c.messages.map((m) => {
          m.seen = true;
        });
      }
    });
    setChats(c);
    if (!connected || !hubConnection || hubConnection.connectionState != 1) return;
    hubConnection.invoke("setMessageSeen", eventId, clientKey, target, null);
  };

  const likeMessage = (messageId) => {
    if (!connected || !hubConnection || hubConnection.connectionState != 1) return;
    hubConnection.invoke("like", messageId, eventId);
  };

  const selectChat = (target) => {
    const c = Array.from(chats);
    let selectedChat = c.find((c) => c.target == target);
    let cc = currentChat;
    if (selectedChat) {
      cc = selectedChat.target;
      let chatIndex = c.indexOf(c.find((c) => c.target == selectedChat.target));
      if (chatIndex > -1) {
        c[chatIndex].seen = true;
        c[chatIndex].messages.map((m) => {
          m.seen = true;
        });
      }

      if (target != "ALL") {
        setMessageSeen(target);
      }
    } else {
      cc = target;
      c.push({
        lastChange: "",
        messages: [],
        previewText: "",
        previewPreFix: "",
        target: target,
        seen: true,
      });
    }

    setAutoScrollLocked(false);
    setHiddenMessages(0);
    setMissedGroupMessages(0);
    setCurrentChat(cc);
  };

  const scrollToBottom = () => {
    const c = Array.from(chats);
    let currentChatConversation = c.find((c) => c.target == currentChat);
    if (currentChatConversation && !currentChatConversation.seen) {
      let index = c.indexOf(currentChatConversation);
      if (index > -1) c[index].seen = true;
      c.seen = true;
      if (currentChat != "ALL") {
        setMessageSeen(currentChat);
      }
    }
    setHiddenMessages(0);
    setMissedGroupMessages(0);
    handleScroll(true);
  };

  const onScroll = (manual = false) => {
    if (manual) {
      const c = Array.from(chats);
      const scrollTop = scrollRef.current.scrollTop;
      if (initalScrollPos >= 150 && scrollTop <= initalScrollPos - 150) {
        setAutoScrollLocked(true);
      }

      if (initalScrollPos <= scrollTop) {
        let currentChatConversation = c.find((c) => c.target == currentChat);

        if (currentChatConversation && !currentChatConversation.seen) {
          let index = c.indexOf(currentChatConversation);
          if (index > -1) c[index].seen = true;
          c.seen = true;
          if (c.target != "ALL") {
            setMessageSeen(currentChat);
          }
        }
        setAutoScrollLocked(false);
        setHiddenMessages(0);
      }
    }
  };

  const handleScroll = (toBottom = false) => {
    let chatIndex = chats.indexOf(chats.find((c) => c.target == currentChat));
    if (chatIndex > -1) {
      let index = chats[chatIndex].messages.slice(messagesToShow * -1).length - 1;
      if (index > -1 && lastMessageRef.current) {
        try {
          lastMessageRef.current.scrollIntoView({
            block: "end",
            behavior: "smooth",
          });
          if (autoScrollLocked == true || toBottom == true) setAutoScrollLocked(false);

          if (scrollRef.current) {
            setTimeout(() => {
              if (scrollRef.current) {
                let isp = scrollRef.current.scrollTop;
                setInitalScrollPos(isp);
                setMissedGroupMessages(0);
              }
            }, 1500);
          }
        } catch (error) {
          console.error(error);
        }
      }
    }
  };

  const api = useMemo(() => {
    const restrictions = (chat) => {
      if (!allowModeratorChat && chat.target == "MODERATOR") return false;
      if (disableGroupChat && chat.target == "ALL") return false;
      return true;
    };
    const filteredChats = chats.filter(restrictions);
    return {
      ...props,
      currentChat,
      chats: filteredChats,
      loaded,
      autoScrollLocked,
      hiddenMessages,
      initalScrollPos,
      missedGroupMessages,
      messagesToShow,
      connectionList: chatConnections,
      chatMessageRef,
      chatBlock,
      scrollRef,
      onScroll: onScroll,
      lastMessageRef,
      selectChat,
      preview,
      likeMessage,
      setMessageSeen,
      handleScroll: handleScroll,
      scrollToBottom,
    };
  }, [
    props,
    currentChat,
    props.clientKey,
    chats,
    lastMessageRef.current,
    loaded,
    autoScrollLocked,
    chatBlock,
    hiddenMessages,
    initalScrollPos,
    missedGroupMessages,
    props.interactionAllowOneToOneChat,
    messagesToShow,
    allowModeratorChat,
    disableGroupChat,
    chatConnections,
  ]);

  const chatTemplate = useMemo(() => (backstage ? backstageChatStyle : chatStyle(template)), [template, backstage]);

  const { header, primaryColor, secondaryColor, badgePillColor } = chatTemplate;

  if ((props.settings.collapsible && collapsed) || (props.settings.collapsible && preview)) {
    return (
      <Fab
        style={{ background: header.background, left: "calc(100% - 57px)", top: "calc(100% - 65px)", position: "absolute" }}
        aria-label="chat-fab"
        onClick={() => {
          setMissedGroupMessages(0);
          setHiddenMessages(0);
          setCollapsed(!collapsed);
          elevateParentContainer(collapsed);
        }}
      >
        <div
          className="badge-pill"
          style={{
            background: badgePillColor,
            display: hiddenMessages + missedGroupMessages > 0 ? "block" : "none",
          }}
        />

        <ChatBubbleRoundedIcon style={{ color: primaryColor }} />
      </Fab>
    );
  }

  return (
    <>
      {props.settings.collapsible ? (
        <div
          className="chat-close-arrow"
          onClick={() => {
            setMissedGroupMessages(0);
            setHiddenMessages(0);
            setCollapsed(!collapsed);
            elevateParentContainer(collapsed);
          }}
        >
          <Tooltip title={<SystemLabel name="CollapseChat" />}>
            <Fab style={{ background: header.background }}>
              <CloseIcon style={{ color: primaryColor }} />
            </Fab>
          </Tooltip>
        </div>
      ) : null}

      <ChatContainer {...combineProps([api, { chatTemplate }])} />
    </>
  );
}

function mapStateToProps(state) {
  return {
    template: state.template.template ? state.template.template.content : null,
    cms: state.cms,
  };
}
export default connect(mapStateToProps)(ChatModule);
